import { ChangeDetectionStrategy, Component, OnInit } from '@angular/core';
import { ManagePaymentMethodsBaseComponent } from '@luggagehero/features/user';

@Component({
  selector: 'lh-manage-payment-methods',
  templateUrl: 'manage-payment-methods.component.html',
  styleUrls: ['manage-payment-methods.component.scss'],
  changeDetection: ChangeDetectionStrategy.Default,
  standalone: false,
})
export class ManagePaymentMethodsComponent extends ManagePaymentMethodsBaseComponent implements OnInit {}
